// tslint:disable-next-line: eofline
export const ApiUrl = 'https://www.auth.wbidmax.com/WBidCoreService/api/'; //Production
// export const ApiUrl = 'http://localhost:61541/api/';
//  export const ApiUrl = "https://www.auth.wbidmax.com/WBidCoreServiceTest/api/";
// export const ApiUrl = "https://www.auth.wbidmax.com/WBidCoreServiceTestDBQA/api/"; //Test

//export const SWAapiUrl = 'https://service.east.0.crewbid.qa.swalife.com/itest/'; //Test SWA APIs - 'https://service.crewbid.dev.swalife.com/itest/'
// export const SWAOauthUrl = 'https://sso.fed.qa.aws.swalife.com/'; //'https://sso.fed.dev.aws.swalife.com/';


export class SWAApiUrlProvider {
    public static get SWAapiUrl(): string {
        const env = localStorage.getItem('SWAEnvConfig');
        if (env === 'qa') {
            return 'https://service.east.0.crewbid.qa.swalife.com/itest/';
        } else if (env === 'dev') {
            return 'https://itest.service.east.0.crewbid.dev.swalife.com/';
        } else if (env === 'prod') {
            return 'https://service.crewbid.swalife.com/golden/';
        }
    }

    public static get SWAOauthUrl(): string {
        const env = localStorage.getItem('SWAEnvConfig');
        if (env === 'qa') {
            return 'https://sso.fed.qa.aws.swalife.com/';
        } else if (env === 'dev') {
            return 'https://sso.fed.dev.aws.swalife.com/';
        } else if (env === 'prod') {
            return 'https://sso.fed.prod.aws.swalife.com/';
        }
    }
}
